import React, { type FC, type PropsWithChildren } from 'react';

import { withImage } from '@lucid/hooks';

import type { Lucid } from '../../types/types';
import Image from '../image/image';
import VideoPlayer from '../video/video-player/video-player';

export type BlogVideoProps = {
  item: Lucid.Directus.Generated.Video;
};

const BlogVideo: FC<PropsWithChildren<BlogVideoProps>> = ({ item }) => (
  <figure
    key={item.id}
    css={theme => ({
      label: 'blogImage',
      margin: `${theme.space.s40}px 0`,
      textAlign: 'center',
    })}
  >
    <VideoPlayer
      description={item.translations?.[0]?.alt_description ?? item.alt_text}
      descriptionElementId={`${item.id}-description`}
      loop={item.should_loop}
      placeholder={() =>
        item.preview_image?.filename_disk && (
          <Image imageAlt={item.preview_image?.translations?.[0]?.alt || ''} imageSrc={withImage(item.preview_image)} />
        )
      }
      shouldAutoPlay={item.should_autoplay}
      url={item.external_url ?? withImage(item.video_file)}
    />
    {item.translations?.[0]?.caption && (
      <figcaption
        css={theme => ({
          fontStyle: 'italic',
          fontSize: theme.fontSizes.fs12,
          color: theme.colors.coolGrey[60],
          marginTop: theme.space.s8,
        })}
      >
        {item.translations?.[0]?.caption}
      </figcaption>
    )}
  </figure>
);

export default BlogVideo;
